<!--@format-->
<template>
    <div class="manage-document-approval-popup">
        <div v-if="element.type === 'approval'" class="approve-document">
            <p class="first-paregraph">
                Once you click on "Approve and Send" the document will be sent out to its respective
                recipients.
            </p>
            <div class="actions-container">
                <app-button class="cancel-button" @click="handleClose">Cancel</app-button>
                <app-button class="continue-btn" @click="handleEmitAction">
                    Approve and Send
                </app-button>
            </div>
        </div>
        <div v-if="element.type === 'denial'" class="deny-document">
            <p class="first-paregraph">
                <span class="bold">{{ element.documentName }}</span> has been denied and the
                salesperson has been notified
            </p>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
import EventBus from '@/scripts/event-bus';

export default {
    name: 'manage-document-approval-popup',

    components: {
        'app-button': AppButton,
    },

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleEmitAction() {
            EventBus.$emit('document:approved');
            this.handleClose();
        },
    },
};
</script>

<style>
.manage-document-approval-popup .first-paregraph {
    margin-bottom: 32px;
    padding: 0px 32px;
}

.manage-document-approval-popup .approve-document .actions-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 28px 0 12px;
    border-top: 2px solid #e9e9ef;
}

.manage-document-approval-popup .approve-document .actions-container .app-button.cancel-button {
    border: 2px solid #cac6cb;
    color: #382153;
    width: 152px;
}

.manage-document-approval-popup .approve-document .actions-container .app-button.cancel-button {
    width: 172px;
}
</style>
